export const ORDER_LIST = "ORDER_LIST";
export const IS_ORDER_LIST = "IS_ORDER_LIST";
export const AFTER_UPDATE_STATUS = "AFTER_UPDATE_STATUS";
export const IS_UPDATING = "IS_UPDATING";
export const ORDER_DETAILS = "ORDER_DETAILS";
export const IS_ORDER_DETAILS = "IS_ORDER_DETAILS";
